import { createContext, useContext } from 'react';

export type HeaderTitle = {
  title: string;
  subtitle: string;
};

export enum ValidationType {
  Full = 'full',
  Draft = 'draft',
}

export type SubmitFunction = (validationType: ValidationType) => void;

type HeaderContextType = {
  setSubmit: (submit: SubmitFunction) => void;
  setIsFormLoading: (isFormLoading: boolean) => void;
  isFormLoading: boolean;
  triggerSubmit: SubmitFunction;
  headerTitle?: HeaderTitle;
  setHeaderTitle: (title: HeaderTitle) => void;
};

export const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export const useHeaderContext = (): HeaderContextType => {
  const context = useContext(HeaderContext);
  if (context === undefined) {
    throw new Error('useHeaderContext must be used within a HeaderProvider');
  }
  return context;
};
